<!-- =========================================================================================
  File Name: ClientList.vue
  Description: Client List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="items-center">
        <!-- ITEMS PER PAGE -->
        <div class="vx-row">
          <div class="vx-col sm:w-5/12 w-full mt-4">
            <vs-input
              class="w-full"
              label="Channel ID"
              name="ChannelID"
              v-model="ChannelID"
            />
            <!--<span
                class="text-danger text-sm"
                v-show="errors.has('ChannelID')"
                >{{ errors.first("ChannelID") }}</span
              >-->
          </div>
          <div class="vx-col sm:w-5/12 w-full mt-4">
            <vs-input
              class="w-full"
              label="User1"
              name="User1"
              v-model="UserID1"
            />
            <!--<span class="text-danger text-sm" v-show="errors.has('User1')">{{
                errors.first("User1")
              }}</span>-->
          </div>
          <div class="vx-col sm:w-2/12 w-full mt-4">
            <vs-button
              type="gradient mr-4 mt-5"
              v-if="role == 1"
              v-on:click="initRTM"
              >Start</vs-button
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mt-4">
            <ul id="ulLog">
              <li>
                <h4><u>LOG</u></h4>
              </li>
              <li v-for="item in logData">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import ls from "@/common/localStorage";

// Store Module
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import AgoraRTM from "agora-rtm-sdk";
var Session_UserId = ls.getSessionValueByKey("UserId");

//console.log(db);
//const event_collectionName = 'sayek-dev';
let vm;
export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  //props: {
  //  data: {
  //    type: Object,
  //    required: true,
  //  },
  //},
  data() {
    return {
      // Filter Options
      rtm_client: AgoraRTM.createInstance("4b88772b431645288736acca1a8dd087"),
      rtm_channel: null,
      role: null,
      ChannelID: "",
      UserID1: "",
      logData: [],
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],

      searchQuery: "",
    };
  },
  watch: {
    /*roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }*/
  },
  computed: {
    //
  },
  mounted() {
    //
  },
  created() {
    this.role = ls.getSessionValueByKey("Role");
  },
  methods: {
    initRTM() {
      vm = this;
      if (vm.ChannelID != "") {
        if (vm.rtm_client != undefined) {
          vm.InitAgoraRTMClient();
          if (vm.rtm_channel == undefined) {
            //vm.rtm_channel = vm.rtm_client.createChannel(vm.ChannelID);
            //vm.InitAgoraRTMChannel();
            vm.AgoraClientLogin();
          }
        }
      }
    },

    InitAgoraRTMClient() {
      if (vm.rtm_client != undefined) {
        vm.rtm_client.on("ConnectionStateChange", (newState, reason) => {
          console.log(
            "on connection state changed to " + newState + " reason: " + reason
          );
        });

        // event listener for receiving a peer-to-peer message.
        vm.rtm_client.on("MessageFromPeer", ({ text }, peerId) => {
          vm.logData.push(peerId + ":" + text);
          //alert(peerId + ":" + text);
          // text: text of the received message; peerId: User ID of the sender.
          //$("#chat_list").append("<div class='left chat-msg'>" + text + "</div>");
          console.log(
            "AgoraRTM msg from user " + peerId + " recieved: \n" + text
          );
        });
      }
    },

    //InitAgoraRTMChannel() {
    //	if (vm.rtm_channel != undefined) {
    //		vm.rtm_channel.on('MemberJoined', (memberId) => {
    //			//alert("MemberJoined:" + memberId);
    //			vm.addAttendee(memberId)
    //		});
    //		vm.rtm_channel.on('MemberLeft', (memberId) => {
    //			//alert("MemberLeft:" + memberId);
    //			vm.removeAttendee(memberId)
    //			//vm.currentAttendeeCount--;
    //			//vm.currentAttendeeCount = vm.getMemberCount();
    //		});
    //	}
    //},

    AgoraClientLogin() {
      //alert(Session_UserId);
      if (vm.UserID1 != "") {
        let tkn = null;
        if (vm.rtm_client == undefined) return;
        vm.rtm_client
          .login({ token: tkn, uid: Session_UserId.toString() })
          .then(() => {
            console.log("AgoraRTM client login success");
            if (vm.rtm_channel != undefined) {
              //vm.JoinRTMChannel();
            } else {
              console.log(
                "failed to join channel for error: Channel is not initialized."
              );
            }
          })
          .catch((err) => {
            console.log("AgoraRTM client login failure", err);
          });
      }
    },

    //JoinRTMChannel() {
    //  if (vm.rtm_channel === undefined) return;
    //  vm.rtm_channel
    //    .join()
    //    .then(() => {
    //      //alert();
    //      debugger;
    //      //vm.addAttendee(vm.uid);
    //      //vm.getPreviouslyJouinedMembers();
    //    })
    //    .catch((error) => {
    //      console.log("failed to join channel for error: " + error);
    //    });
    //},

    //LeaveRTMChannel() {
    //  if (vm.rtm_channel === undefined) return;
    //  vm.rtm_channel
    //    .leave()
    //    .then(() => {
    //      //remove Attendee
    //      //vm.removeAttendee(vm.uid)
    //      //vm.currentAttendeeCount--;
    //      //vm.currentAttendeeCount = vm.getMemberCount();
    //      //vm.getPreviouslyJouinedMembers();
    //    })
    //    .catch((error) => {
    //      console.log("failed to join channel for error: " + error);
    //    });
    //},

    //sendP2PMessage(m) {
    //  // An RtmMessage object.
    //  const msg = {
    //    description: undefined,
    //    messageType: "TEXT",
    //    rawMessage: undefined,
    //    text: m,
    //  };
    //  const recipient = Session_UserId; //"onairadmin@e2m.live"; // The user ID of the remote user.
    //  //const recipient = "221001"; // The user ID of the remote user.
    //  const options = {
    //    enableHistoricalMessaging: true,
    //    enableOfflineMessaging: false,
    //  };

    //  // p2p message
    //  vm.rtm_client
    //    .sendMessageToPeer(msg, recipient, options)
    //    .then((sendResult) => {
    //      if (sendResult.hasPeerReceived) {
    //        //alert("Received")
    //        //$("#chat_list").append("<div class='right chat-msg'>" + msg.text + "</div>");
    //        /* Your code for handling the event that the remote user receives the message. */
    //      } else {
    //        /* Your code for handling the event that the message is received by the server but the remote user cannot be reached. */
    //      }
    //    })
    //    .catch((error) => {
    //      console.log("failed to sendMessageToPeer for error: " + error);
    //      /* Your code for handling the event of a message send failure. */
    //    });
    //},
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>